import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {FileUploader, ConfirmationPrompt} from '../../';

import * as Actions from 'actions';


class IncidentReportGenerator extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      show_delete_file_prompt : false,
      show_generate_report_prompt : false,
    }

    this.handleCreateReport = this.handleCreateReport.bind(this)
    this.handleDeleteFiles = this.handleDeleteFiles.bind(this)
    this.renderReportIcons = this.renderReportIcons.bind(this)
  }

  handleCreateReport() {
    this.props.createIncidentReport()
    this.setState({show_generate_report_prompt : false})
  }

  handleDeleteFiles() {
    this.setState({show_delete_file_prompt : false})
    this.props.beginDeleteReportPDFS()
  }

  renderReportIcons() {
    let pdfs = this.props.incident.adjuster_report_pdfs;
    if(pdfs) {
      return (
        pdfs.map((pdf, index) => {
          return (
            <div className='col-md-4 col-xs-6 indv-report-icon-wrapper' key={index}>
              <div
                className={`indv-report-inner-wrapper ${pdf.selected ? 'selected-report-file' : ''}`}
                onClick={() => {
                  pdf.selected ?
                  this.props.toggleIncidentReportSelected(false, pdf.file._id) :
                  this.props.toggleIncidentReportSelected(true, pdf.file._id)
                  }}
                  >
                <h6>{pdf.file.originalName}</h6>
                <i className='fa fa-file-pdf-o report-pdf-icon' />
                {(() => {
                  if(pdf.idx != null)
                    return <p>pg <strong>{pdf.idx}</strong></p>
                })()}
              </div>
            </div>
          )
        })
      )
    }
  }


  render() {
    return (
      <div className='row report-creator-container'>
        {(() => {
          let _self = this;
          if(this.state.show_delete_file_prompt) {
            return (
              <ConfirmationPrompt
                handleCancelPrompt={() => {_self.setState({show_delete_file_prompt : false})}}
                handleConfirmPrompt={_self.handleDeleteFiles}
                show_condition={_self.state.show_delete_file_prompt}
                title='Delete Selected Files?'
                body='Are you sure you want to delete all the selected files? This action cannot be undone.'
                confirm_button_text='Delete'
                cancel_button_text='Cancel'
                bsSize='small'
              />
            )
          }
          else if(_self.state.show_generate_report_prompt) {
            return (
              <ConfirmationPrompt
                handleCancelPrompt={() => {_self.setState({show_generate_report_prompt : false})}}
                handleConfirmPrompt={_self.handleCreateReport}
                show_condition={_self.state.show_generate_report_prompt}
                title='Generate Report?'
                body='Would you like to generate a PDF report with the selected files?'
                confirm_button_text='Confirm'
                cancel_button_text='Cancel'
                type='success'
                bsSize='small'
              />
            )
          }
          else if(_self.props.client_incidents.show_new_report_prompt) {
            return (
              <ConfirmationPrompt
                handleCancelPrompt={() => {_self.props.hideNewReportPrompt()}}
                anchor_href={_self.props.client_incidents.report_link.report_url}
                onClick={() => {this.props.hideNewReportPrompt()}}
                show_condition={_self.props.client_incidents.show_new_report_prompt}
                title='Report Ready'
                body='Click below to download your report'
                confirm_button_text='Download'
                cancel_button_text='Cancel'
                type='primary'
                bsSize='small'
              />
            )
          }
        })()}
        <div className='col-md-12 col-xs-12'>
          <div className='col-md-8 col-xs-12'>
            <h3 className='text-muted'><i className='fa fa-file-pdf-o' /> Create Report</h3>
            {(() => {
              let _self = this;
              if(_self.props.incident._id) {
                let pdfs = this.props.incident.adjuster_report_pdfs
                return (
                  <div className='report-creator'>
                    {(() => {
                      if(_self.props.client_incidents.generating_report || _self.props.client_incidents.deleting_report_pdfs) {
                        return (
                          <div className='report-spinner'>
                            <i className="fa fa-spinner fa-spin fa-5x fa-fw"></i>
                            <br/>
                            <span className="loading-text">
                              Loading...
                            </span>
                          </div>
                        )
                      }
                      else {
                        return (
                          <div>
                            <p>Add PDF files here to create a compiled report for this damage incident</p>
                            <FileUploader
                              endpoint={`/upload/clientIncident/${_self.props.incident._id}/adjuster_report_pdfs`}
                              iconFileTypes={['pdf']}
                              onSuccess={(res) => {
                                this.props.addIncidentReportPDF(JSON.parse(res.xhr.response).files[0])}}
                            />
                            <div className='current_reports'>
                              {_self.renderReportIcons()}
                              <div className='row'>
                                <div className='col-xs-12 mt-sm'>
                                  <div className='btn-group btn-group-justified'>
                                    <div
                                      className='btn btn-danger'
                                      onClick={() => {_self.setState({show_delete_file_prompt : true})}}
                                      disabled={(!pdfs || !pdfs.find(file => file.selected)) ? true : false}
                                      >
                                      Delete
                                    </div>
                                    <div
                                      className='btn btn-primary'
                                      onClick={() => {_self.setState({show_generate_report_prompt : true})}}
                                      disabled={(!pdfs || !pdfs.find(file => file.selected)) ? true : false}
                                      >
                                      Create Report
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    })()}
                  </div>
                  )
              }
              else {
                return (
                  <div className='alert alert-info'>
                    <h4>Select a damage incident to create a report</h4>
                  </div>
                )
              }
            })()}
          </div>
        </div>
      </div>
    )
  }
}

let mapStateToProps = ({client_incidents}) => ({client_incidents})

export default connect(mapStateToProps, Actions)(IncidentReportGenerator);



// WEBPACK FOOTER //
// ./src/browser/components/client/incidents/incident-report-generator.js